import { ViewParams } from 'shared/types';
import { createAction } from 'typesafe-actions';

export const saveExternalConfig = createAction('config/SAVE_EXTERNAL_CONFIG')<Partial<ViewParams>>();
